import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import styled from "@emotion/styled";
import Cookies from 'js-cookie';
import { Input, Modal, Button, message, Spin } from "antd";
import { UserOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';

import startImg from '../assets/record/start.png'
import endImg from '../assets/record/end.png'
import musicImg from '../assets/record/music.png'
import emptyMusic from '../assets/record/empty_music.png'

import AudioReactRecorder, { RecordState } from 'audio-react-recorder';
import convertAudioStereoToMono from '../components/AudioUtils';

import MySlider, { range } from "../components/Slider/Slider";
import Login from "../components/Login/Login";
import { AudioCopyParam } from "../service/AIapi";
import VoiceService, { TtsApiPathv2 } from '../service/VoiceService';
import { AudioPlaybackBar } from '../components/AudioPlaybackBar';
import Describe from '../components/Describe/Describe';
import { SoundCopyDescribeData } from '../components/staticDescribeData';
import { setStoreAudioList, setModelList } from "../store/model_slice/model";
import moment from 'moment';

import './style.scss';
import { get } from 'lodash';
import SensitiveDataConsent from '../components/SensitiveDataConsent';
const { TextArea } = Input;
const PlayerStatus = {
    start: '立即合成',
    done: '已合成',
    running: '合成中',
    stop: '合成中',
    resume: '继续播放',
    replay: '重播',
}

const SoundCopy = (): React.ReactElement => {
    const dispatch = useDispatch()
    const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
    const login = useSelector((state: any) => state?.guard?.isLogin);
    const minorMode = useSelector((state: any) => state?.guard?.minorMode);
    const audioStoreList = useSelector((state: any) => state?.model?.audioList);
    const modelStoreList = useSelector((state: any) => state?.model?.model);
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState<boolean>(false)
    const [remain, setRemain] = useState<number>(300)
    // 音量
    const [volume, setVolume] = useState<number>(1);
    // 语速
    const [speed, setSpeed] = useState<number>(1)
    // 口语化等级
    const [level, setLevel] = useState<number>(1)
    // 音调
    const [pitch, setPitch] = useState<number>(1)
    const [btnText, setBtnText] = useState<string>(PlayerStatus.start)
    const [audioSrc, setAudioSrc] = useState('');

    const [model, setModel] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    // 录音
    const [recordState, setRecordState] = useState(null)
    const [isCancel, setIsCancel] = useState(false)
    const [audioData, setAudioData] = useState(null)
    const [isMediaStreamAvailable, setIsMediaStreamAvailable] = useState(true)
    const [selectIndex, setSelectIndex] = useState(null);
    // 已合成声音
    const [audioList, setAudioList] = useState([]);
    //1 | 2
    const [step, setStep] = useState('1');
    const [name, setName] = useState('');
    const [input, setInput] = useState(`摩尔线程自研音色复刻技术，仅需30秒音频样本，即可快速复刻高自然度和高拟真度的TTS音色。MooreThread's Voice-as-a-service technology can quickly clone any voice using only a 30-second audio sample and synthesize high-quality multi-lingual speech.`)
    const [voiceList, setvoiceList] = useState([
        {
            text: '轻轻的，我走了，正如我轻轻地来；我轻轻的招手，作别西天的云彩。',
            voice: null,
            status: 'notReady'
        },
        {
            text: '那河畔的金柳，是夕阳的新娘；波光里的艳影，在我的心头荡漾。',
            voice: null,
            status: 'notReady'
        },
        {
            text: '当春天一到来，太阳把大地照得很温暖的时候，燕子就向拇指姑娘告别了。',
            voice: null,
            status: 'notReady'
        },
        {
            text: '握在手里，不一定就是我们真正拥有的；我们所拥有的，也不一定就是我们真正铭刻在心的！',
            voice: null,
            status: 'notReady'
        }
    ])
    const [selectModel, setSelectModel] = useState(null);
    const [noAudio, setNoAudio] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [sensitiveConsent, setSensitiveConsent] = useState(false);
    const sensitiveConsentRef = useRef(false);
    const requestAbortRef = useRef<AbortController | null>(null);
    const recordingEpochRef = useRef(0);
    useEffect(() => {
        setModel(modelStoreList)
        setModel(audioStoreList)
        setIsLogin(!!Cookies.get('access_token'))
        if (!minorMode && navigator && navigator.mediaDevices) {
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(function () {
                    setNoAudio(false)
                })
                .catch(function (err) {
                    setNoAudio(true)
                });
        }
    }, [minorMode])

    useEffect(() => {
        setIsLogin(!!Cookies.get('access_token'))
    }, [login])

    useEffect(() => {
        dispatch(setModelList(model));
    }, [model])

    useEffect(() => {
        dispatch(setStoreAudioList(audioList));
    }, [audioList])

    const ChangeLevel = (vol: string) => {
        setLoading(false);
        setBtnText(PlayerStatus.start);
        let rate: number = range[vol.slice(0, -1)][0];
        setLevel(rate);
    }

    const ChangePitch = (vol: string) => {
        setLoading(false);
        setBtnText(PlayerStatus.start);
        let rate: number = range[vol.slice(0, -1)][0];
        setPitch(rate);
    }

    const ChangeVolume = (vol: string) => {
        setLoading(false);
        setBtnText(PlayerStatus.start);
        let rate: number = range[vol.slice(0, -1)][0];
        setSpeed(rate)
    }

    const ChangeSpeed = (speed: string) => {
        setLoading(false);
        setBtnText(PlayerStatus.start);
        let rate: number = range[speed.slice(0, -1)][0];
        setSpeed(rate)
    }

    const GenerateSpeech = () => {
        if (!sensitiveConsentRef.current) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return;
        }
        switch (btnText) {
            case PlayerStatus.stop:
                setBtnText(PlayerStatus.resume);
                break;
            case PlayerStatus.start:
                GenerateAudio();
                setLoading(true);
                setBtnText(PlayerStatus.running);
                break;
            case PlayerStatus.resume:
                setBtnText(PlayerStatus.stop);
                break;
            case PlayerStatus.replay:
                setBtnText(PlayerStatus.stop);
                break;
            default:
                break;
        }
    }

    const base64ToAudioUrl = (base64) => {
        // 将Base64字符串转换为二进制数据
        let binaryString = atob(base64);
        let len = binaryString.length;
        let bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        // 创建一个Blob对象
        let blob = new Blob([bytes], { type: 'audio/wav' });
        return URL.createObjectURL(blob);
    }

    const msToTime = (duration: number) => {
        let seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60);
        // hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

        const pad = (num: number) => (num < 10 ? "0" + num : num);

        return `${pad(minutes)}:${pad(seconds)}`;
    }

    const GenerateAudio = () => {
        if (!sensitiveConsentRef.current) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return;
        }
        requestAbortRef.current?.abort();
        const controller = new AbortController();
        requestAbortRef.current = controller;
        let select = model[selectModel];
        const speechParam = {
            cluster: 'mt_llm_tts',
            input: {
                text: input,
                text_type: "plain",
                enable_subtitle: false,
                enable_phoneme_timestamp: false
            },
            voice_config: {
                voice_name: select.voice_id,
                oral_level: level,
            },
            audio_config: {
                encoding: "wav",
                speed_ratio: speed,
                volume_ratio: Number(volume),
                pitch_ratio: pitch
            },
            source:2
        }

        // 状态查询
        VoiceService.post(`${TtsApiPathv2}/voice_clone/status`, {
            voice_id: select.voice_id
        }, { signal: controller.signal }).then(response => {
            if (!sensitiveConsentRef.current) {
                return;
            }
            let resData = response.data || {}
            if (resData.status === 1000) {
                if (resData['voice_status'] === 4) {
                    VoiceService.post(`${TtsApiPathv2}/generate`, speechParam, { signal: controller.signal }).then(res => {
                        if (!sensitiveConsentRef.current) {
                            return;
                        }
                        let data = res.data;
                        if (data.status === 1000) {
                            setLoading(false);
                            let time = get(data, 'addition.duration', 0);
                            let timeStr = time ? msToTime(time) : ""
                            setAudioList([...audioList, {
                                url: base64ToAudioUrl(data.audio),
                                time: timeStr,
                                name: select.name,
                                createTime: moment(select.crateTime).format('YYYY-MM-DD HH:mm')
                            }])
                            setBtnText(PlayerStatus.start);
                            messageApi.open({
                                type: 'success',
                                content: '合成成功',
                            });
                        }else{
                            messageApi.open({
                                type: 'warning',
                                content: `${data['status']}:${data['status_text']}`,
                            });
                        }
                    })
                        .catch(error => {
                            if (error?.code === 'ERR_CANCELED') {
                                return;
                            }
                            if (error.response && error.response.status === 500) {
                                const reader = new FileReader();
                                reader.onload = function () {
                                    // The result attribute contains the contents of the blob as a text string
                                    console.log(this.result);
                                    alert(`服务端错误（请保留错误信息，反馈给相关技术支持人员）:\n${this.result}`);
                                };
                                reader.readAsText(error.response.data);
                            } else if (error.response && error.response.status === 400) {
                                const reader = new FileReader();
                                reader.onload = function () {
                                    // The result attribute contains the contents of the blob as a text string
                                    console.log(this.result);
                                    alert(`客户端错误（请根据以下错误信息，修改输入内容）:\n${this.result}`);
                                };
                                reader.readAsText(error.response.data);
                            } else if (error.message === "Request failed with status code 504"
                                || error.message === "Request failed with status code 502") {
                                alert('服务异常：请参考使用说明书进行排查')
                            }
                            else {
                                // Handle other possible errors here
                                alert('未知错误: ' + error.message);
                            }
                            setLoading(false);
                            setBtnText(PlayerStatus.start);
                        })
                        .finally(() => {
                            setBtnText(PlayerStatus.start);
                        });
                } else {
                    setBtnText(PlayerStatus.start);
                    messageApi.open({
                        type: 'warning',
                        content: '此模型暂未准备好，请稍后再试。',
                    });
                }
            } else {
                setBtnText(PlayerStatus.start);
                messageApi.open({
                    type: 'warning',
                    content: `错误码：${resData['status']}（请保留错误信息，反馈给相关技术支持人员）`,
                });
            }
        }).catch((error) => {
            if (error?.code === 'ERR_CANCELED') {
                return;
            }
            setLoading(false);
            setBtnText(PlayerStatus.start);
        })


    }

    const handleStartRecord = () => {
        let isFisrtCheck = true;
        if (isFisrtCheck || !isMediaStreamAvailable) {
            checkAudioRecorderAvailable();
            isFisrtCheck = false;
        }
        if (isMediaStreamAvailable) {
            start();
        }
    };

    const checkAudioRecorderAvailable = () => {
        if (!navigator || !navigator.mediaDevices) {
            alert('获取录音设备失败，请检查浏览器或录音设备！');
            setIsMediaStreamAvailable(false)
            return false;
        }
        // 使用getUserMedia获取媒体流
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then((stream) => {
                // 如果成功获取媒体流，do something ...
                console.log('获取媒体流成功.');
                setIsMediaStreamAvailable(true)

                // 关闭媒体流以释放资源
                stream.getTracks().forEach((track) => {
                    track.stop();
                });
                return true;
            })
            .catch((error) => {
                console.error('获取媒体流失败:', error);
                alert('获取媒体流失败，不支持录音，请尝试开启 HTTPS: ' + error.message);
                setIsMediaStreamAvailable(false)
            });
        return false;
    }

    const start = () => {
        setRecordState(RecordState.START)
        setIsCancel(false)
    }

    const stop = () => {
        setRecordState(RecordState.STOP)
    }

    // audioData contains blob and url
    const onStop = (data) => {
        const recordingEpoch = recordingEpochRef.current;
        if (isCancel || !sensitiveConsentRef.current) {
            console.log('Cancel recording, clear audio data.');
            setAudioData(null)
            return;
        }

        // 设置录音数据到状态
        setAudioData(data)
        const reader = new FileReader();
        reader.onload = (event) => {
            if (!sensitiveConsentRef.current || recordingEpoch !== recordingEpochRef.current) {
                return;
            }
            if (event.target && event.target.result) {
                const base64Data = event.target.result.toString().split(',')[1];
                if (selectIndex !== null) {
                    let newList = voiceList;
                    let item = newList[selectIndex];
                    item['voice'] = base64Data;
                    item['status'] = 'finish'
                    newList[selectIndex] = item
                    setvoiceList([...newList])
                    setSelectIndex(null)
                }
            }
        };
        convertAudioStereoToMono(data.blob)
            .then((monoBlob) => {
                if (!sensitiveConsentRef.current || recordingEpoch !== recordingEpochRef.current) {
                    return;
                }
                console.log("双声道转单声道，音频处理完成");
                reader.readAsDataURL(monoBlob);
            })
            .catch((error) => {
                console.error("双声道转单声道，音频处理出错", error);
            });

    }
    const ChangeInput = (e: any) => {
        setInput(e.target.value);
        setRemain(300 - e.target.value.length);
        setLoading(false);
    }

    const createModel = () => {
        if (minorMode) {
            messageApi.open({ type: 'warning', content: '未成年人模式下不能使用声音复刻功能' });
            return false;
        }
        if (!isLogin) {
            messageApi.open({
                type: 'warning',
                content: '请在登录后使用此功能！',
            });
            return false;
        }
        if (!sensitiveConsent) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return false;
        }
        setModalOpen(true)
    }

    const setModalClose = () => {
        stop()
        reset()
        setModalOpen(false)
    }

    const toNextStep = () => {
        if (!sensitiveConsentRef.current) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return;
        }
        setStep('2')
    }

    // 名称改变
    const NameChange = (e: any) => {
        setName(e.target.value);
    }

    // 录制
    const toRecord = (index: number) => {
        if (minorMode) {
            messageApi.open({ type: 'warning', content: '未成年人模式下不能录制声音' });
            return false;
        }
        if (!sensitiveConsentRef.current) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return false;
        }
        if (noAudio) {
            messageApi.open({
                type: 'warning',
                content: '请先获取录音权限',
            });
            return false;
        }
        const item = voiceList[index];
        // 在存在其他录音进程时，阻止动作
        if (selectIndex !== index && selectIndex !== null) {
            messageApi.open({
                type: 'warning',
                content: '请先完成当前录音操作',
            });
            return false;
        }
        if (item.status === 'notReady' || item.status === 'finish') {
            recordingEpochRef.current += 1;
            setSelectIndex(index);
            handleStartRecord()
            voiceList[index]['status'] = 'recording'
            voiceList[index]['voice'] = null
            setvoiceList(voiceList)
        } else {
            stop();
        }
    }

    // 设置模型
    const toSetModel = () => {
        if (!sensitiveConsentRef.current) {
            messageApi.open({ type: 'warning', content: '请先阅读并同意语音文件敏感个人信息处理提示' });
            return;
        }
        requestAbortRef.current?.abort();
        const controller = new AbortController();
        requestAbortRef.current = controller;
        setIsLoading(true)
        const speechParam: AudioCopyParam = {
            audios: voiceList.map(item => {
                return {
                    audio_bytes: item.voice,
                    audio_format: 'wav',
                    text: item.text
                }
            }),
        }
        VoiceService.post(`${TtsApiPathv2}/voice_clone/audio/upload`, speechParam, { signal: controller.signal }).then(res => {
            if (!sensitiveConsentRef.current) {
                return;
            }
            let data = res.data || {}
            if (data.status !== 1000) {
                messageApi.open({
                    type: 'warning',
                    content: `${data['status']}:${data['status_text']}`,
                });
            } else if (data.status === 1000) {
                messageApi.open({
                    type: 'success',
                    content: '创建成功',
                });
                setModel([...model, {
                    name: name,
                    task_id: data['task_id'],
                    voice_id: data['voice_id'],
                    crateTime: Date.now()
                }]);
            }
        }).catch(error => {
            if (error?.code === 'ERR_CANCELED') {
                return;
            }
            if (error.response && error.response.status === 500) {
                const reader = new FileReader();
                reader.onload = function () {
                    // The result attribute contains the contents of the blob as a text string
                    console.log(this.result);
                    alert(`服务端错误（请保留错误信息，反馈给相关技术支持人员）:\n${this.result}`);
                };
                reader.readAsText(error.response.data);
            } else if (error.response && error.response.status === 400) {
                const reader = new FileReader();
                reader.onload = function () {
                    // The result attribute contains the contents of the blob as a text string
                    console.log(this.result);
                    alert(`客户端错误（请根据以下错误信息，修改输入内容）:\n${this.result}`);
                };
                reader.readAsText(error.response.data);
            } else if (error.message === "Request failed with status code 504"
                || error.message === "Request failed with status code 502") {
                alert('服务异常：请参考使用说明书进行排查')
            }
            else {
                // Handle other possible errors here
                alert('未知错误: ' + error.message);
            }
            setLoading(false);
            setBtnText(PlayerStatus.start);
        })
            .finally(() => {
                reset()
            });

    }

    const reset = () => {
        setModalOpen(false)
        setIsLoading(false)
        setAudioData(null)
        setSelectIndex(null)
        setIsCancel(false)
        setIsMediaStreamAvailable(true);
        setStep('1')
        setName('')
        voiceList.map(item => {
            item.voice = null;
            item.status = 'notReady'
            return item
        })
        setvoiceList(voiceList)
    }

    const toSelecttModel = (index) => {
        if (selectModel === index) {
            setSelectModel(null)
        } else {
            setSelectModel(index)
            setBtnText(PlayerStatus.start);
        }
    }

    const delModel = (index) => {
        model.splice(index);
        setModel([...model])
    }

    const toPlay = (index) => {
        let audioItem = audioList[index]
        setAudioSrc(audioItem.url)
    }

    const isEmptyModel = () => {
        return selectModel === null || !input || !isLogin || !sensitiveConsent;
    }

    const handleSensitiveConsentChange = (checked: boolean) => {
        sensitiveConsentRef.current = checked;
        setSensitiveConsent(checked);
        if (checked) {
            return;
        }

        requestAbortRef.current?.abort();
        requestAbortRef.current = null;
        recordingEpochRef.current += 1;
        setIsCancel(true);
        stop();
        setModalOpen(false);
        setIsLoading(false);
        setLoading(false);
        setAudioData(null);
        setAudioSrc('');
        setSelectIndex(null);
        setSelectModel(null);
        setStep('1');
        setName('');
        setBtnText(PlayerStatus.start);
        setvoiceList(currentList => currentList.map(item => ({
            ...item,
            voice: null,
            status: 'notReady'
        })));
    }

    return (
        <>
            {contextHolder}
            <DescribeDiv>
                {SoundCopyDescribeData?.map((item, index) => {
                    return < Describe data={item} index={index} key={index} />
                })}
            </DescribeDiv>
            <SensitiveDataConsent checked={sensitiveConsent} onChange={handleSensitiveConsentChange} description="为创建和使用声音复刻模型处理我录制的语音文件" />
            < SoundFrame >
                <Container>
                    <SoundContainer>
                        <SoundTitle>选择模型</SoundTitle>
                        <SoundDesc>请先选择一个模型，再进行下一个操作</SoundDesc>
                        <SoundCardContainer>
                            {
                                !model.length ?
                                    <UnLoginBox>
                                        <UserIcon>
                                            <UserOutlined style={{
                                                width: '48px',
                                                height: '48px',
                                                fontSize: '48px',
                                                color: '#E4E4E4'
                                            }} />
                                        </UserIcon>
                                        <AddTag onClick={createModel}>创建模型<PlusOutlined style={{
                                            marginLeft: '5px'
                                        }} /></AddTag>
                                    </UnLoginBox>
                                    :
                                    <ModelBox>
                                        {
                                            model.map((item, index) => {
                                                return <TagBox style={{
                                                    borderColor: selectModel === index ? '#ff671d' : 'transparent'
                                                }} key={index} onClick={() => {
                                                    toSelecttModel(index)
                                                }}>
                                                    <Tagtext>{item.name}</Tagtext>
                                                    <CloseOutlined onClick={() => delModel(index)} />
                                                </TagBox>
                                            })
                                        }
                                        {
                                            <LittleAddTag onClick={createModel}>创建模型<PlusOutlined style={{
                                                marginLeft: '5px'
                                            }} /></LittleAddTag>
                                        }
                                    </ModelBox>
                            }
                        </SoundCardContainer>
                        <SoundTitle>合成的声音</SoundTitle>
                        {
                            audioList.length === 0 ? <EmptyAudio>
                                <EmptyImg>
                                    <img src={emptyMusic} alt="" />
                                </EmptyImg>
                                <EmptyText>您还没有合成声音~</EmptyText>
                            </EmptyAudio> : null
                        }
                        <AudioList>
                            {
                                audioList.map((item, index) => {
                                    return <AudioItem key={index} onClick={() => { toPlay(index) }}>
                                        <ImgBox>
                                            <img src={musicImg} alt="" />
                                        </ImgBox>
                                        <AudioCont>
                                            <AudioInfo>
                                                <Tagtext>{item.name}</Tagtext>
                                                <Timetext>{item.createTime}</Timetext>
                                            </AudioInfo>
                                            <TimeFormat>{item.time}</TimeFormat>
                                        </AudioCont>
                                    </AudioItem>
                                })
                            }
                        </AudioList>
                    </SoundContainer>
                    <TextContainer>
                        <SoundTitle style={{ marginTop: 20, marginBottom: 12 }}>输入文本</SoundTitle>
                        <InputArea>
                            <TextArea maxLength={300} style={{
                                padding: 20,
                                resize: "none",
                                width: "100%",
                                height: "100%",
                                background: "#F6F6F6",
                                borderRadius: 2
                            }}
                                variant={"borderless"}
                                onChange={ChangeInput}
                                value={input}
                            />
                            <AreaTip>体验版还可以输入 <span style={{ color: "#FF671D" }}>{remain}</span> 个字，超出部分合成将被截断</AreaTip>
                        </InputArea>
                        {/* 
                             <ConfigDiv>
                            <VolumeDiv>
                                <SoundTitle>口语化等级</SoundTitle>
                                <MySlider sliderWidth={133} state={'compound'} initVal={level} change={ChangeLevel} type="level" />
                            </VolumeDiv>
                            <VolumeDiv >
                                <SoundTitle>音调</SoundTitle>
                                <MySlider sliderWidth={133} state={'compound'} initVal={pitch} change={ChangePitch} type="pitch" />
                            </VolumeDiv>
                            <VolumeDiv>
                                <SoundTitle>音量</SoundTitle>
                                <MySlider sliderWidth={133} state={'compound'} initVal={volume} change={ChangeVolume} type="vol_radio" />
                            </VolumeDiv>
                            <VolumeDiv >
                                <SoundTitle>语速</SoundTitle>
                                <MySlider sliderWidth={133} state={'compound'} initVal={speed} change={ChangeSpeed} type="speeds" />
                            </VolumeDiv>
                        </ConfigDiv>
                        */}
                    </TextContainer>
                </Container>
                {AudioPlaybackBar(isEmptyModel, loading, GenerateSpeech, btnText, audioSrc)}
            </SoundFrame >
            <Login></Login>
            <Modal
                title="创建模型"
                width={400}
                maskClosable={false}
                centered
                open={modalOpen}
                onOk={() => setModalOpen(false)}
                onCancel={setModalClose}
                footer={(_, { OkBtn, CancelBtn }) => (
                    step === '1' ?
                        <FootBtn>
                            <Button type='primary' disabled={!name} onClick={toNextStep}>下一步</Button>
                        </FootBtn>
                        : <FootBtn>
                            <Button type='primary' loading={isLoading} disabled={!sensitiveConsent || voiceList.some(item => { return item.status !== 'finish' })} onClick={toSetModel}>立即创建</Button>
                        </FootBtn>

                )}
            >

                {
                    step === '1' ?
                        <div>
                            <FormTitle>模型命名</FormTitle>
                            <Input value={name} onChange={NameChange} placeholder='请为您的模型取个名字~' />
                        </div>
                        :
                        <div className='voiceForm'>
                            <Spin spinning={isLoading} >

                                <FormTitle>点击每段录音按钮进行录制<br />
                                    四段完成后，即可合成你的专属模型</FormTitle>
                                {
                                    voiceList.map((item, index) => {
                                        return <div className={`cardItem ${item.status === 'finish' ? 'active' : ''}`} key={index}>
                                            <div className='cardLine'>
                                                <div className='lineTop'></div>
                                                <div className='cardIndex'>0{index + 1}</div>
                                                <div className='lineBot'></div>
                                            </div>
                                            <div className='cardCont'>
                                                <div className='content'>
                                                    <div className='textBox'>{item.text}</div>
                                                    <VoiceBtn onClick={() => {
                                                        toRecord(index)
                                                    }}>
                                                        {
                                                            item.status === 'notReady' || item.status === 'finish' ?
                                                                <img src={startImg} alt="" />
                                                                : <img src={endImg} alt="" />
                                                        }
                                                    </VoiceBtn>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                            </Spin>
                        </div>
                }

            </Modal>
            <div style={{ display: 'none' }}>
                <AudioReactRecorder hidden state={recordState} onStop={onStop} />
            </div>
        </>
    );
}

export default SoundCopy;

const DescribeDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    margin-top: 60px;
    height: 198px;
`

const SoundContainer = styled.div`
//   background-color: lightblue;
    flex: 1;
`

const SoundCardContainer = styled.div`
//   background-color: orange;
  max-height: 94%;
  overflow-x: clip !important;
  /* padding: 0 10px; */
  margin: 0px 0px 17px 0;
  
`

const TextContainer = styled.div`
//   background-color: lightgreen;
  width: 442px;
  padding-left: 20px;
`

const Container = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  /* grid-gap: 10px; */
`

const SoundFrame = styled.div`
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
//   margin-top: 60px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`

const SoundTitle = styled.span`
  font-size: 16px;
  color: #222222;
  line-height: 16px;
  font-weight: 600;
`

const SoundDesc = styled.span`
  font-size: 12px;
  color: #999999;
  line-height: 16px;
  margin-left:10px;
`

const InputArea = styled.div`
  width: 100%;
  height: 198px;
  position: relative;
  padding-top: 12px;
`

const AreaTip = styled.span`
  position: absolute;
  left: 20px;
  bottom: 20px;

  font-size: 12px;
  color: #999999;
  line-height: 12px;
  font-weight: 400;
`

const ConfigDiv = styled.div`
  display: flex;
  flex-wrap:wrap;
  justify-content: space-between;
  margin-top: 20px;
`

const VolumeDiv = styled.div`
  width: 48%;
  height: 100px;
//   margin-top: 12px;
`

const UnLoginBox = styled.div`
  width:100%;
  height: 198px;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
`
const UserIcon = styled.div`
    width:64px;
    height:64px;
    border-radius:50%;
    overflow:hidden;
    background: #F6F6F6;
    margin-bottom:16px;
    display:flex;
    align-items:center;
    justify-content: center;
`

const AddTag = styled.div`
    padding:2px 8px;
    display: flex;
    align-items: center;
    height:28px;
    line-height:24px;
    font-size:14px;
    border:1px solid #FF671D;
    border-radius: 4px;
    color:#FF671D;
    cursor: pointer;
`

const ModelBox = styled.div`
    padding:10px 0;
    box-sizing:border-box;
    width:100%;
    flex-wrap:wrap;
    height: 198px;
    display:flex;
`

const FormTitle = styled.p`
    margin:14px auto;
    width:224px;
    word-break:break-all;
    text-align:center;
    line-height:21px;
    color:#222;
    font-family: PingFang SC;
    font-size: 14px;
    font-variation-settings: "opsz" auto;
`

const FootBtn = styled.div`
    width:100%;
    padding-top:10px;
    display:flex;
    align-items:center;
    justify-content: center;
`

const VoiceBtn = styled.div`
    flex-shrink: 0;
    width:36px;
    height:36px;
    border-radius: 2px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.06);
    margin-left:20px;
    cursor: pointer;
    display:flex;
    align-items:center;
    justify-content: center;
`

const TagBox = styled.div`
    width: 122px;
    height: 38px;
    padding:0 8px;
    box-sizing:border-box;
    display:flex;
    align-items:center;
    justify-content:space-between;
    border-radius: 2px;
    line-height:38px;
    cursor: pointer;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    margin-right:4px;
    margin-bottom:4px;
    color: #999;    
    border:1px solid transparent;
`

const Tagtext = styled.span`
    width: 68px;
    font-family: PingFang SC;
    font-size: 14px;
    letter-spacing: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #222222;
`

const Timetext = styled.span`
    font-family: PingFang SC;
    font-size: 12px;
    color: #222222;
`

const LittleAddTag = styled.div`
    width: 122px;
    height: 38px;
    padding:0 8px;
    box-sizing:border-box;
    display:flex;
    align-items:center;
    justify-content:space-between;
    border-radius: 2px;
    line-height:38px;
    font-size:14px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border:1px solid transparent;
    color:#FF671D;
    cursor: pointer;
`

const AudioList = styled.div`
    width:100%;
    height:auto;
    max-height:198px;
    overflow-y:auto;
    display:flex;
    flex-wrap:wrap;
    padding:10px 0px;
    box-sizing:border-box;
    cursor: pointer;
`

const AudioItem = styled.div`
    width: 253px;
    height: 72px;
    border-radius: 2px;
    margin-right:5px;
    margin-bottom:5px;
    display:flex;
    align-items:center;
    padding:10px;
    box-sizing:border-box;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
`

const ImgBox = styled.div`
    width:48px;
    height:48px;
    border-radius:50%;
    background: #FAF0E9;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:12px;
    margin-bottom:4px;
`
const AudioCont = styled.div`
    flex:1;
`
const AudioInfo = styled.div`
    width:100%;
    display:flex;
    align-items:center;
    justify-content:space-between;
`

const TimeFormat = styled.div`
    font-size:12px;
    color: #666666;
`

const EmptyAudio = styled.div`
    width:100%;
    height:150px;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
`

const EmptyImg = styled.div`
    width:64px;
    height:64px;
    border-radius:50%;
    display:flex;
    justify-content:center;
    align-items:center;
    background: #F6F6F6;
`

const EmptyText = styled.div`
    font-size: 12px;
    color: #999999;
    margin-top:10px;
`
